const baudrates = document.getElementById("baudrates") as HTMLSelectElement;
const connectButton = document.getElementById("connectButton") as HTMLButtonElement;
const traceButton = document.getElementById("copyTraceButton") as HTMLButtonElement;
const disconnectButton = document.getElementById("disconnectButton") as HTMLButtonElement;
const resetButton = document.getElementById("resetButton") as HTMLButtonElement;
const eraseButton = document.getElementById("eraseButton") as HTMLButtonElement;
const programButton = document.getElementById("programButton");
const filesDiv = document.getElementById("files");
const terminal = document.getElementById("terminal");
const programDiv = document.getElementById("program");
const lblBaudrate = document.getElementById("lblBaudrate");
const lblConnTo = document.getElementById("lblConnTo");
const table = document.getElementById("fileTable") as HTMLTableElement;

import { ESPLoader, FlashOptions, LoaderOptions, Transport } from "../assets/bundle.js";
import { serial } from "web-serial-polyfill";
if (!navigator.serial && navigator.usb) navigator.serial = serial;

declare let Terminal; // Terminal is imported in HTML script
declare let CryptoJS; // CryptoJS is imported in HTML script

const term = new Terminal({ cols: 120, rows: 40 });
term.open(terminal);

let device = null;
let transport: Transport;
let chip: string = null;
let esploader: ESPLoader;

const fileArray = [];

disconnectButton.style.display = "none";
traceButton.style.display = "none";
eraseButton.style.display = "none";
resetButton.style.display = "none";
filesDiv.style.display = "none";

const espLoaderTerminal = {
  clean() {
    term.clear();
  },
  writeLine(data) {
    term.writeln(data);
  },
  write(data) {
    term.write(data);
  },
};

function cleanUp() {
  device = null;
  transport = null;
  chip = null;
}

traceButton.onclick = async () => {
  if (transport) {
    transport.returnTrace();
  }
};

resetButton.onclick = async () => {
  if (transport) {
    await transport.setDTR(false);
    await new Promise((resolve) => setTimeout(resolve, 100));
    await transport.setDTR(true);
  }
};

eraseButton.onclick = async () => {
  eraseButton.disabled = true;
  try {
    await esploader.eraseFlash();
  } catch (e) {
    console.error(e);
    term.writeln(`Error: ${e.message}`);
  } finally {
    eraseButton.disabled = false;
  }
};

connectButton.onclick = async () => {
  if (device === null) {
    device = await navigator.serial.requestPort({});
    transport = new Transport(device, true);
  }

  try {
    const flashOptions = {
      transport,
      baudrate: parseInt(baudrates.value),
      terminal: espLoaderTerminal,
    } as LoaderOptions;
    esploader = new ESPLoader(flashOptions);

    lblBaudrate.style.display = "none";
    baudrates.style.display = "none";
    connectButton.style.display = "none";

    chip = await esploader.main();

    if(!chip.startsWith("ESP32-C6")){
      term.writeln("Error! Wrong chip connected. Expected is ESP32-C6");
      await transport.disconnect();
      cleanUp();
      lblBaudrate.style.display = "initial";
      baudrates.style.display = "initial";
      connectButton.style.display = "initial";
      return;
    }
  } catch (e) {
    console.error(e);
    term.writeln("");
    term.writeln(`Error: ${e.message}`);
    await transport.disconnect();
    cleanUp();
    lblBaudrate.style.display = "initial";
    baudrates.style.display = "initial";
    connectButton.style.display = "initial";
    return;
  }

  console.log("Settings done for :" + chip);
  lblBaudrate.style.display = "none";
  baudrates.style.display = "none";
  lblConnTo.innerHTML = "Connected to device: " + chip;
  lblConnTo.style.display = "block";
  connectButton.style.display = "none";
  disconnectButton.style.display = "initial";
  traceButton.style.display = "initial";
  eraseButton.style.display = "initial";
  filesDiv.style.display = "initial";
};

disconnectButton.onclick = async () => {
  if (transport) await transport.disconnect();

  term.reset();
  lblBaudrate.style.display = "initial";
  baudrates.style.display = "initial";
  connectButton.style.display = "initial";
  disconnectButton.style.display = "none";
  traceButton.style.display = "none";
  eraseButton.style.display = "none";
  lblConnTo.style.display = "none";
  filesDiv.style.display = "none";
  programButton.style.display = "initial";
  resetButton.style.display = "none";
  for (let index = 1; index < table.rows.length; index++) {
    table.rows[index].cells[3].childNodes[0].value = "0";
  }
  cleanUp();
};

programButton.onclick = async () => {
  const progressBars = [];

  for (let index = 1; index < table.rows.length; index++) {
    const row = table.rows[index];
    const progressBar = row.cells[3].childNodes[0];

    progressBar.textContent = "0";
    progressBars.push(progressBar);
  }

  try {
    const flashOptions: FlashOptions = {
      fileArray: fileArray,
      eraseAll: false,
      compress: true,
      flashSize: "keep",
      flashFreq: "80MHz",
      flashMode: "DIO",
      reportProgress: (fileIndex, written, total) => {
        progressBars[fileIndex].value = (written / total) * 100;
      },
      calculateMD5Hash: (image) => CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
    } as FlashOptions;
    programButton.style.display = "none";
    eraseButton.style.display = "none";
    await esploader.writeFlash(flashOptions);
  } catch (e) {
    console.error(e);
    programButton.style.display = "initial";
    term.writeln(`Error: ${e.message}`);
  } finally {
    // Switch to console
    await transport.disconnect();
    await transport.connect(115200);
    await transport.setDTR(false);
    await new Promise((resolve) => setTimeout(resolve, 100));
    await transport.setDTR(true);
    resetButton.style.display = "initial";
    while (true) {
      const val = await transport.rawRead();
      if (typeof val !== "undefined") {
        term.write(val);
      } else {
        console.log("Leaving monitor");
        break;
      }
    }
  }
};

// addFileButton.onclick = () => {
function addFileRow(addr, path, size) {
  const rowCount = table.rows.length;
  const row = table.insertRow(rowCount);

  //Column 1 - Offset
  const cell1 = row.insertCell(0);
  const element1 = document.createElement("span");
  element1.innerHTML = addr;
  cell1.appendChild(element1);

  // Column 2 - File selector
  const cell2 = row.insertCell(1);
  const element2 = document.createElement("span");
  element2.innerHTML = path;
  cell2.appendChild(element2);

  // Column 3 - File Size
  const cell3 = row.insertCell(2);
  const element3 = document.createElement("span");
  element3.innerHTML = size+" B";
  cell3.appendChild(element3);

  // Column 4  - Progress
  const cell4 = row.insertCell(3);
  cell4.classList.add("progress-cell");
  cell4.innerHTML = `<progress value="0" max="100" style="width:100%"'></progress>`;
};

function addFileForFlashing(outArray, addr, path) {
  console.log("load", addr, path);
  var request = new XMLHttpRequest();
  request.open('GET', path, true);
  request.responseType = 'blob';
  request.onload = function() {
      console.log("blob", addr, path, request.response);
      var size = request.response.size;
      var reader = new FileReader();
      reader.onload =  function(e){
          outArray.push({ data: e.target.result, address: parseInt(addr) });
          console.log("push", addr, path);
          addFileRow(addr, path, size);
      };
      reader.readAsBinaryString(request.response);
  };
  request.send();
}

addFileForFlashing(fileArray, "0x0", "bootloader.bin");
addFileForFlashing(fileArray, "0x8000", "partition-table.bin");
addFileForFlashing(fileArray, "0xd000", "ota_data_initial.bin");
addFileForFlashing(fileArray, "0x10000", "network_adapter.bin");
